import React from "react";
import { FaDotCircle } from "react-icons/fa";
const YdbikeDetails = () => {
  return (
    <div className="py-4 px-[8%]">
      <div className="w-full relative h-24 py-5 bg-slate-900 text-white text-center">
        <h1 className="text-4xl font-bold">YD BIKE</h1>
      </div>
      <div
        className="grid grid-cols-1 lg:grid-cols-2 gap-5"
        data-aos="fade-up"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
      >
        <div className="text-center w-full h-72 boxOne ">
          <div className="divOne div1"></div>
          {/* <img src={} alt="" />
          <img
            src="https://i.ibb.co/8rMH7g2/ydhome1.png"
            alt="" className="w-full h-72"
          /> */}
          <h1 className="text-3xl font-bold text-slate-900">Home Page</h1>
        </div>
        <div className="text-center dashboard1">
          {/* <img src={} alt="" /> */}
          <div className="dashOne dash1"></div>
          {/* <img
            src="https://i.ibb.co/59vYTdh/ydDash.png"
            alt=""
          /> */}
          <h1 className="text-3xl font-bold text-slate-900">Dashboard</h1>
        </div>
      </div>

      <div className=" text-center mt-32 mx-auto">
        <h1 className="text-3xl font-bold mb-7 ">
          Used Languages and Technologies
        </h1>
        <div className="usedTechnologies grid grid-cols-6 my-6 mx-auto w-[90%] text-center justify-center">
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://iconape.com/wp-content/png_logo_vector/tailwind-css-logo.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcEPtZG69vhynupLCfGDE1KhYCaLQkoiPXFTEFK00Wv1OLQROIt61A7gAXzo93N66rrIw&usqp=CAU"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://www.pngitem.com/pimgs/m/385-3850320_png-transparent-mongodb-icon-mongodb-logo-png-download.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full text-center justify-center">
            <img
              src="https://cdn4.iconfinder.com/data/icons/google-i-o-2016/512/google_firebase-2-512.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
          <div className="w-10 h-10 rounded-full">
            <img
              src="https://cdn.iconscout.com/icon/free/png-256/node-js-1174925.png"
              alt=""
              className="w-10 h-10"
            />
          </div>
        </div>
      </div>
      <div
        className="details"
        data-aos="fade-down"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
      >
        <div className="text-center">
          <h1 className="text-2xl text-slate-900 font-bold">
            YD BIKE (
            <a
              className="text-blue-600"
              href="https://ydbike-9f725.web.app/home"
            >
              Live Site
            </a>
            :{" "}
            <a
              className="text-blue-600"
              href="https://github.com/kutub98/DreamBike"
            >
              Client Code
            </a>{" "}
            :{" "}
            <a
              className="text-blue-600"
              href="https://github.com/kutub98/dream-bike-server"
            >
              Server Code
            </a>
            )
          </h1>
        </div>
        <div className="">
          <h1>
            It's based on Selling and buying used product. Here sellers can sell
            bikes and buyers can buy books, and the admin will be able to
            observe all the bikes.
          </h1>
          <ul>
            <li className="flex items-center">
              {" "}
              <FaDotCircle className="mr-5"></FaDotCircle>
              It's based on sell or buy used products. User can be a seller or
              buy.
            </li>
            <li className="flex items-center">
              {" "}
              <FaDotCircle className="mr-5"></FaDotCircle>
              Seller can add products, after add he can edit his/her products or
              delete
            </li>
            <li className="flex items-center">
              {" "}
              <FaDotCircle className="mr-5"></FaDotCircle>
              And admin can maintain the registration request of the users.
              Admin also adds a new event on this website
            </li>
            <li className="flex items-center">
              {" "}
              <FaDotCircle className="mr-5"></FaDotCircle>
              Database Integration, Implementing Authentication & Authorization,
              secureToken using JWT
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default YdbikeDetails;
